import { useCallback, useContext } from 'react';
import { gql, useMutation } from '@apollo/client';
import { UserContext } from '@secretescapes/cauldron';
import { i18n } from '@secretescapes/i18n';

const ADD_FAVORITE = gql`
  mutation AddFavorite($saleId: String!, $userId: String!) {
    addFavorite(saleId: $saleId, userId: $userId) {
      success
      message
    }
  }
`;

const REMOVE_FAVORITE = gql`
  mutation RemoveFavorite($saleId: String!, $userId: String!) {
    removeFavorite(saleId: $saleId, userId: $userId) {
      success
      message
    }
  }
`;

interface UseFavouriteOptions {
  saleId: string;
  translations?: Record<string, string>;
}

export const useFavourite = ({ saleId, translations }: UseFavouriteOptions) => {
  const { userId } = useContext(UserContext);
  const [addFavorite] = useMutation(ADD_FAVORITE);
  const [removeFavorite] = useMutation(REMOVE_FAVORITE);

  const handleFavouriteChange = useCallback(
    async (notChecked: boolean) => {
      if (!userId) {
        return;
      }

      if (notChecked) {
        await addFavorite({ variables: { saleId, userId } });
      } else {
        await removeFavorite({ variables: { saleId, userId } });
      }
    },
    [addFavorite, removeFavorite, saleId, userId]
  );

  const buttonText = translations
    ? i18n('favorites.salepage.addTo.label', [], translations)
    : undefined;

  return { handleFavouriteChange, buttonText };
};
